import React, { lazy } from "react";
import { Route, Routes } from "react-router-dom";
import { UserInfo } from "CommonLibrary";
import HealthFile from "../common/HealthFile";
//import { authTokenCookie } from '../utils/CookieMaker';
//import {UserAuthorization} from '../common/Authorization';
//import { userRoleVal } from '../utils/constants';
//import { Environment } from '../utils/Environment';
//const RoleLogin = lazy(() => import('../common/RoleLogin'))

const EmployeeDiscountCreateForm = lazy(() =>
  import("../component/Screens/employeeDiscount/employeeDiscountForm")
);
//let { userInfo } = authTokenCookie();

//let isAuthorized = (userInfo && userInfo.userRole && (userInfo.userRole !== userRoleVal.assetProtection &&
  //  userInfo.userRole !== userRoleVal.giftCard)) ? true : false;

const route = (
  <React.Fragment>
    <Routes>
      <Route path="/employeeDiscountForm" element={<EmployeeDiscountCreateForm />}    />
      <Route path="/health" element={<HealthFile />} />
      <Route path="/myinfo" element={<UserInfo />} />
      <Route path="/" element={<EmployeeDiscountCreateForm />} />
      {/* <Route path="/DashBoard" element={<DashBoard />}/> */}
      {/* <Route
          path="/edform"
          element={<EmployeeDiscountForm />}
        /> */}
    </Routes>
  </React.Fragment>
);

export default route;
